module.exports = __webpack_public_path__ + "static/media/fullscreen.b2f7b382.png";